// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"198":"b957d0bf","213":"9d2c5fc2","239":"74145d56","455":"6a0c4507","488":"843db0ae"}[chunkId] + ".chunk.js";
};